import React from 'react';

var PlayForRealButtonHolder = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-play-for-real-btn-holder' }, children);
};

export { PlayForRealButtonHolder };
